import {Component, computed, inject} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {OrganizationService} from '../services/organization.service';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {BillingStatus} from '../../models/organizations';

@Component({
  selector: 'app-subscription',
  standalone: true,
  imports: [MatIcon, MatButton],
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.scss'
})
export class SubscriptionComponent {
  organizationService = inject(OrganizationService);
  authService = inject(AuthService);
  router = inject(Router);

  status = computed<BillingStatus | undefined>(() =>
    this.organizationService.lastBillingStatus() ??
    this.organizationService.currentOrganization()?.billingStatus
  );

  title = computed(() => {
    switch (this.status()) {
      case 'pending_payment': return 'Pagamento pendente';
      case 'trial': return 'Período de avaliação';
      case 'suspended': return 'Conta suspensa';
      default: return 'Assinatura inativa';
    }
  });

  message = computed(() => {
    switch (this.status()) {
      case 'pending_payment':
        return 'Identificamos um pagamento pendente. Para continuar utilizando o sistema, regularize sua assinatura.';
      case 'trial':
        return 'Seu período de avaliação está ativo. Para garantir o acesso contínuo, contrate um plano.';
      case 'suspended':
        return 'O acesso desta conta foi suspenso. Entre em contato para reativar sua assinatura.';
      default:
        return 'Sua assinatura não está ativa. Entre em contato com nosso time para regularizar o acesso.';
    }
  });

  async logout() {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }
}
